module.exports = __webpack_public_path__ + "media/images/proof_links/proof_green/twitter-3d6c2a86ae2a6284c470aa1501ed1c5c.svg";